<ion-card>
    <p class="title">Bericht versturen</p>
    <p class="subtitle">Kies het type bericht</p>

    <!-- Message Type Selector -->
    <ion-segment [(ngModel)]="selectedMessageType" mode="ios">
        <ion-segment-button [value]="MessageType.CourierWaiting">
            <ion-label>Ben er</ion-label>
        </ion-segment-button>
        <ion-segment-button [value]="MessageType.ArrivingSoon">
            <ion-label>Onderweg</ion-label>
        </ion-segment-button>
        <ion-segment-button [value]="MessageType.Delayed">
            <ion-label>Vertraging</ion-label>
        </ion-segment-button>

    </ion-segment>


    <!-- ETA input, only shown when needed -->
    <div class="eta-selector"
        *ngIf="selectedMessageType === MessageType.Delayed || selectedMessageType === MessageType.ArrivingSoon">

        <ion-button fill="clear" size="small" (click)="decreaseEta()" [disabled]="etaMinutes <= 1">
            <ion-icon name="remove-outline"></ion-icon>
        </ion-button>

        <ion-input class="eta-input" type="number" min="1" [value]="etaMinutes" (ionInput)="onEtaInput($event)"
            inputmode="numeric">
        </ion-input>

        <ion-button fill="clear" size="small" (click)="increaseEta()">
            <ion-icon name="add-outline"></ion-icon>
        </ion-button>

        <p>minuten</p>
    </div>

    <!-- Live Preview of SMS -->
    <div class="preview">
        {{messagePreview}}
    </div>

    <!-- Error feedback -->
    <p class="error" *ngIf="error">{{ error }}</p>

    <!-- Action buttons -->
    <div class="actions">
        <ion-button color="secondary" (click)="cancel()" [disabled]="isSending">
            Annuleren
        </ion-button>
        <ion-button color="primary" (click)="confirm()" [disabled]="isSending">
            Versturen
        </ion-button>
    </div>
</ion-card>